import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

const InputFieldLabel = styled(Typography)`
  font-weight: 400;
  font-size: 12px;
  line-height: 160%;
  color: ${COLOR_TEXT_MAIN};
`;

export default InputFieldLabel;
